// @flow
import React, {type Node} from 'react';

import s from './item.scss';

type PropsType = {
    children: Node,
};

/**
 *  Functional-component for Item
 *  @param {PropsType} props - Received props
 *  @returns {Node} - Rendered Item stateless component
 */
export const Item = (props: PropsType): Node => <div className={s.item}>{props.children}</div>;
